import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class SolicitudesService {
  private EDNPOINT = environment.ENDPOINTS.VARIABLES_GLOBALES;
  private solicitudesEndpoint = environment.ENDPOINTS.SOLICITUDES;
    constructor(
      private http: HttpClient
    ) { }
  crearSolicitud(data:any) {
    return this.http.post(this.solicitudesEndpoint, data)
  }
  aprobar(id: number, id_jefe_turno: number) {
    return this.http.put(this.solicitudesEndpoint+'/'+id+'/'+id_jefe_turno, {
      status: 'approved'
    });
  }

  denegar(id: number, id_jefe_turno: number) {
    return this.http.put(this.solicitudesEndpoint+'/'+id+'/'+id_jefe_turno, {
      status: 'rejected'
    });
  }
  listenRequests() {
      const endpoint = environment.ENDPOINTS.SOLICITUDES;
      const eventSource = new EventSource(
        `${endpoint}/stream`
      );

      eventSource.onmessage = (event) => {

        const requests = JSON.parse(event.data);

        if (requests.length > 0) {
          const latest = requests[0];

          console.log('Nueva solicitud:', latest);

          //this.openModal(latest);
        }
      };
    }
  listenSolicitudes(id:number){
    return this.http.get(this.solicitudesEndpoint+'/'+id);
  }
  listenSolicitudesAll(){
    return this.http.get(this.solicitudesEndpoint+'/stream');
  }
}
